import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import MovieItem from '../components/MovieItem';

export default function Home() {
  const [list, setList] = useState([]);
  const inputRef = useRef();
  const nav = useNavigate();
  const [query] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const onSub = (e) => {
    e.preventDefault();
    const inputVal = inputRef.current.value;
    nav("/?s=" + inputVal)
  }

  useEffect(() => {
    doApi();
  },[query])

  const doApi = async() => {
    const queryS = query.get("s") || "superman"
    const url = `https://www.omdbapi.com/?s=${queryS}&apikey=25832c59`;
    try{
      setLoading(true);
      setList([]);
      const {data} = await axios.get(url);
      setList(data.Search);
      setLoading(false);
    }
    catch(error){
       console.log(error);
    }
  }

  return (
    <div className="container">
      <div className="bg-dark text-white rounded p-4 my-4 text-center shadow-sm">
        <h1 className="mb-2">Movie Search</h1>
        <p className="mb-0 text-white-50">Search and explore movies using the OMDb database</p>
      </div>
      <div className="row justify-content-center">
        <form onSubmit={onSub} className="col-md-6 col-lg-4 mb-4">
          <div className="input-group">
            <input placeholder="search for movies..." ref={inputRef} className="form-control" type="search"/>
            <button className="btn btn-dark">Search</button>
          </div>
        </form>
      </div>
      <div className="row">
        {loading && (
          <div className="text-center my-4">
            <h3 className="text-muted">Loading ...</h3>
          </div>
        )}
        {list.map(item => {
          return (
            <MovieItem key={item.imdbID} item={item} />
          )
        })}
      </div>
    </div>
  )
}
